import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, rydeColors } from "@ryde/theme";

/**
 * A field that shows a value rather than accepting one.
 *
 * Sized to the outlined MUI field it stands beside — 56px tall, `16.5px 14px` of padding, 4px
 * radius, full width — so a column mixing read-only and editable rows lines up instead of stepping.
 * Left as bare text it read as a caption that had lost its input, which on a form of bordered
 * fields looks like something failed to render.
 *
 * Deliberately not MUI's `disabled` treatment: disabled means "not available right now", and these
 * values are never going to be editable. The lighter border and faintly off-white ground carry
 * "read-only" without inviting anyone to hunt for the toggle that enables it.
 */
export const GenericReadonlyTemplateStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "generic-readonly",
  },
)`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${greyMui._900};
  row-gap: 4px;

  .GenericReadonlyTemplate-Label {
    font-size: 11px;
    color: ${blueGreyMui._500};
  }

  .GenericReadonlyTemplate-Value {
    display: flex;
    align-items: center;
    /* The medium outlined input's own box: 56px including the border, 16.5px/14px inside it. */
    box-sizing: border-box;
    min-height: 56px;
    padding: 16.5px 14px;
    border: 1px solid ${rydeColors.whiteButtonBorder};
    border-radius: 4px;
    background-color: ${greyMui._50};
    font-size: 14px;
    line-height: 1.4375;
    /* Values here are data, not captions — a session id is one unbroken 36-character string and the
       notification template renders whole message bodies. Both wrap inside the box rather than
       push the form sideways. */
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }
`;
